import React from 'react';
import { useTranslation } from 'react-i18next';

import { Selector } from '@/components/ui/inputs/selector';


interface SelectorOption {
  value: string;
  label: string;
}

interface AreaPositionSelectorProps {
  areaOptions: SelectorOption[];
  positionOptions: SelectorOption[];
  selectedAreaIds: string[];
  selectedPositionIds: string[];
  onAreaChange: (ids: string | string[]) => void;
  onPositionChange: (ids: string | string[]) => void;
  isLoadingPositions?: boolean;
  showArea?: boolean;
  showPosition?: boolean;
  disabled?: boolean;
}

export const AreaPositionSelector: React.FC<AreaPositionSelectorProps> = ({
  areaOptions,
  positionOptions,
  selectedAreaIds,
  selectedPositionIds,
  onAreaChange,
  onPositionChange,
  isLoadingPositions = false,
  showArea = true,
  showPosition = true,
  disabled = false,
}) => {
  const { t: translate } = useTranslation();

  if (!showArea && !showPosition) return null;

  return (
    <>
      {showArea && (
        <Selector
          label={translate('attendance:dimensionalFilter.area')}
          value={selectedAreaIds}
          options={areaOptions}
          onChange={onAreaChange}
          multiple
          searchable
          disabled={disabled}
          placeholder={translate('attendance:dimensionalFilter.allSelected')}
        />
      )}
      {showPosition && (
        <Selector
          label={translate('attendance:dimensionalFilter.position')}
          value={selectedPositionIds}
          options={positionOptions}
          onChange={onPositionChange}
          multiple
          searchable
          isLoading={isLoadingPositions}
          disabled={disabled || isLoadingPositions}
          placeholder={translate('attendance:dimensionalFilter.allSelected')}
        />
      )}
    </>
  );
};
